/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';


export interface BugReportRequest {

    id?: string;

    /**
     * Title of the bug report
     */
    title?: string;

    /**
     * Details of the bug report
     */
    details?: string;

    /**
     * Application reporting the bug
     */
    app?: string;

    /**
     * Host serving the app that is reporting the bug (if available)
     */
    host?: string;

    user?: string;

    /**
     * Logs sent by the users browser
     */
    logs?: string;

    /**
     * User agent of the device when the bug was filed
     */
    agent?: string;

    /**
     * State of local storage when bug was filed
     */
    local_storage?: string;

    /**
     * IP address of the device when the bug was filed
     */
    ip?: string;

    screenshot?: string;

}

@Model('BugReport')
export class ApiBugReport extends BaseModel implements BugReportRequest {

    
    
    id: string;

    /**
     * Title of the bug report
     */
    
    
    title: string;

    /**
     * Details of the bug report
     */
    
    
    details: string;

    /**
     * Application reporting the bug
     */
    
    
    app: string;

    /**
     * Host serving the app that is reporting the bug (if available)
     */
    
    
    host: string;

    
    
    user: string;

    /**
     * Logs sent by the users browser
     */
    
    
    logs: string;

    /**
     * User agent of the device when the bug was filed
     */
    
    
    agent: string;

    /**
     * State of local storage when bug was filed
     */
    
    
    local_storage: string;

    /**
     * IP address of the device when the bug was filed
     */
    
    
    ip: string;

    
    
    screenshot: string;

}
